import React from 'react'

// Components
import User from './User'

const NoUsers = () => <p>There are no users.</p>

const UsersList = ({ users, onDeleteClicked }) => {
  if (!users || users.length === 0) return <NoUsers />

  return(
    <div className="profile-list">
        { 
          users.map(user => 
            <User 
              userInfo={user} 
              key={user.id} 
              onDeleteClicked={onDeleteClicked} 
            />
          )
        }
    </div>
  )
}

export default UsersList;



// WEBPACK FOOTER //
// ./src/components/Admin/UsersList.js